import { JSX } from "react";
import { ProductCarousel } from "@hatch-digital-nl/bravilor-storybook";
import { ProductImageInterface } from "../../interfaces/apiV2/shared/ProductImageInterface";

interface Props {
    isLoading: boolean;
    images: ProductImageInterface[];
    onImageClick: (images: ProductImageInterface[]) => void;
}

export const ProductDetailsCarousel = ({
    isLoading,
    images,
    onImageClick,
}: Props): JSX.Element => {
    const imageCount = isLoading ? 0 : images.length;

    return (
        <ProductCarousel
            loading={isLoading}
            images={images}
            onImageClick={() => onImageClick(images)}
            carouselKey={imageCount}
        />
    );
};
